/**
 * stores cache lifespan in ms
 */
export const storesCacheLifespan: Number = 600000;
